import { Flipper } from 'flip-toolkit';
import whenDomReady from 'when-dom-ready';

const ACTIVE = 'is-active';

/**
 * Initialise all accordions
 */
function initialise() {
  const accordions = Array.from(document.querySelectorAll('.js-ds-accordion'));

  accordions.forEach(initialiseAccordion);
}

/**
 * Initialise the accordion
 * @param {HTMLElement} accordion
 */
function initialiseAccordion(accordion) {
  const flipper = new Flipper({
    element: accordion,
  });

  const items = Array.from(accordion.querySelectorAll('.js-ds-accordion-item'));
  const toggle = accordion.querySelector('.js-ds-accordion-toggle-all');

  if (toggle) {
    toggle.addEventListener('click', event => {
      event.preventDefault();

      const isAnyOpen = items.some(item => item.classList.contains(ACTIVE));

      if (isAnyOpen) {
        toggle.classList.remove(ACTIVE);
      } else {
        toggle.classList.add(ACTIVE);
      }

      items.forEach(item => {
        if (isAnyOpen && item.classList.contains(ACTIVE)) {
          close(item);
        } else if (!isAnyOpen && !item.classList.contains(ACTIVE)) {
          open(item);
        }
      });
    });
  }

  items.forEach((item, index) => {
    const header = item.querySelector('.js-ds-accordion-header');
    const content = item.querySelector('.js-ds-accordion-content');

    if (!header || !content) {
      return;
    }

    flipper.addFlipped({
      element: item,
      flipId: `accordion-item-${index}`,
    });

    flipper.addInverted({
      element: item.firstElementChild,
      parent: item,
    });

    flipper.addFlipped({
      element: header,
      flipId: `accordion-item-header-${index}`,
    });

    flipper.addFlipped({
      element: content,
      flipId: `accordion-item-content-${index}`,
    });

    flipper.addInverted({
      element: content.firstElementChild,
      parent: content,
    });

    header.addEventListener('click', event => {
      event.preventDefault();

      if (item.classList.contains(ACTIVE)) {
        close(item);
      } else {
        open(item);
      }

      const isAnyOpen = items.some(i => i.classList.contains(ACTIVE));

      if (isAnyOpen) {
        if (toggle) {
          toggle.classList.add(ACTIVE);
        }
      } else if (toggle) {
        toggle.classList.remove(ACTIVE);
      }
    });
  });

  /**
   * Open specified item.
   * @param {HTMLElement} item
   */
  function open(item) {
    flipper.recordBeforeUpdate();
    item.classList.add(ACTIVE);
    flipper.update();
  }

  /**
   * Close specified item.
   * @param {HTMLElement} item
   */
  function close(item) {
    flipper.recordBeforeUpdate();
    item.classList.remove(ACTIVE);
    flipper.update();
  }
}

whenDomReady().then(initialise);
